import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { createOrUpdateUserGuardianDetailsGraphQlMutation } from '../../../graphQL/NiatApplicationPortal/mutations/createOrUpdateUserGuardianDetails';
import {
  MutationGraphQlResponseType,
  UpdateUserGuardianDetailsRequestObjectType
} from '../../../services/IbUserAccountsServices/GraphQlService/types';
import { networkCallWithGraphQL } from '../../../utils/AuthAPIUtils';

import { useAccountsRefreshAuthTokens } from '../../useAccountsRefreshAuthTokens';

import { useIbUserAccountsGraphQLService } from '../useIbUserAccountsGraphQLService';

interface UseUpdateUserGuardianDetailsApiInterface {
  updateUserGuardianDetailsGraphQLApi: UseMutateAsyncFunction<
    MutationGraphQlResponseType,
    Error,
    {
      values: UpdateUserGuardianDetailsRequestObjectType;
      accessToken?: string;
    }
  >;
  error: string | null;
  status: MutationStatus;
}

const useUpdateUserGuardianDetailsApi =
  (): UseUpdateUserGuardianDetailsApiInterface => {
    const { ibUserAccountsGraphQLService } = useIbUserAccountsGraphQLService();
    const { refreshTokenApi, getRefreshToken } = useAccountsRefreshAuthTokens();

    const updateUserGuardianDetails = ({
      values,
      accessToken
    }: {
      values: UpdateUserGuardianDetailsRequestObjectType;
      accessToken?: string;
    }) => {
      const mutationDetail = createOrUpdateUserGuardianDetailsGraphQlMutation();

      if (accessToken) {
        return ibUserAccountsGraphQLService.ibUserAccountsGraphQlMutation(
          mutationDetail.mutation,
          {
            user_guardian_details_input: values
          },
          networkCallWithGraphQL(
            refreshTokenApi,
            () => accessToken,
            getRefreshToken
          )
        );
      } else
        return ibUserAccountsGraphQLService.ibUserAccountsGraphQlMutation(
          mutationDetail.mutation,
          {
            user_guardian_details_input: values
          }
        );
    };

    const { mutateAsync, error, status } = useMutation(
      updateUserGuardianDetails,
      {
        mutationKey: ['updateUserGuardianDetailsGraphQLApi']
      }
    );

    return {
      updateUserGuardianDetailsGraphQLApi: mutateAsync,
      error: error ? getAPIErrorMessage(error) : null,
      status
    };
  };

export { useUpdateUserGuardianDetailsApi };
